export default {
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian.',
    successfully_saved: 'Zapisano pomyślnie.',
  },
  form: {
    has_multiple_locations: {
      label: 'Ustaw różne lokalizacje na dany tydzień',
    },
  },
  labels: {
    day_location: '{{day}} lokalizacja {{index}}',
    selected_days: 'Wybrane dni',
    orders_paused: 'Zamówienia wstrzymane',
    open_time: 'Godzina otwarcia',
    close_time: 'Godzina zamknięcia',
  },
  buttons: {
    save: 'Zapisz',
  },
};
